import createApplicantAndToken from './createApplicantAndToken';
import saveSelfieId from './saveSelfieId';
import getSelfieCheckResult from './getSelfieCheckResult';
import getSelfieCheckUpdate from './getSelfieCheckUpdate';

const mutations = {
  CREATE_APPLICANT_AND_TOKEN: createApplicantAndToken,
  SAVE_SELFIE_ID: saveSelfieId,
  GET_SELFIE_CHECK_RESULT: getSelfieCheckResult,
  GET_SELFIE_CHECK_UPDATE: getSelfieCheckUpdate
};

export default mutations;